import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import { useClientSetting } from "@/store/client-setting"
import { parseLanguageFromSearchParams } from "@/utils/language-param"

import { useLanguage } from "./use-language"

let isLanguageInitialized = false

function useInitLanguage() {
  const [searchParams] = useSearchParams()
  const { changeLanguage, language } = useLanguage()
  const forceUseLanguage = useClientSetting((state) => state.forceUseLanguage)
  const hasHydrated = useClientSetting((state) => state.hasHydrated)

  useEffect(() => {
    if (!hasHydrated) return
    if (isLanguageInitialized) return

    const urlLanguage = parseLanguageFromSearchParams(searchParams)
    if (urlLanguage) {
      changeLanguage(urlLanguage, true, true)
      isLanguageInitialized = true
      return
    }

    if (forceUseLanguage) {
      changeLanguage(language as "vi" | "en", true, true)
      isLanguageInitialized = true
      return
    }

    isLanguageInitialized = true
  }, [hasHydrated, changeLanguage, forceUseLanguage, language, searchParams])
}

export { useInitLanguage }
